import { Confidence } from '../types/detection.js';
const confidenceRank = {
    [Confidence.Present]: 3,
    [Confidence.Possible]: 2,
    [Confidence.NeedsReview]: 1,
    [Confidence.NotDetected]: 0,
};
export function mergeDetections(detections) {
    const byAllergen = new Map();
    for (const det of detections) {
        const key = det.allergenId;
        const group = byAllergen.get(key);
        if (group)
            group.push(det);
        else
            byAllergen.set(key, [det]);
    }
    const merged = [];
    for (const group of byAllergen.values()) {
        if (group.length === 1) {
            merged.push(group[0]);
            continue;
        }
        const best = group.reduce((a, b) => confidenceRank[a.confidence] >= confidenceRank[b.confidence] ? a : b);
        const ingredients = [...new Set(group.flatMap((d) => d.triggeringIngredients))];
        const evidenceChain = group.flatMap((d) => d.evidenceChain);
        merged.push({
            ...best,
            triggeringIngredients: ingredients,
            evidenceChain,
        });
    }
    return merged;
}
//# sourceMappingURL=mergeDetections.js.map